// @flow
import * as React from 'react';
import ReactDOM from 'react-dom';
import uniqBy from 'lodash/uniqBy';
import Toggle from 'react-toggled';
import makeComponentTrashable from 'trashable-react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';

import { fetchWithToken, getScribeBackendEndpoint } from '../../utils/http';

type AudioFile = {
  title: string,
  desc: string,
  text?: boolean,
  lang: string,
};

type Props = {
  classes: Object,
  conversationRequested: boolean,
  conversationStarted: boolean,
  openWebsocketCount: number,
  scribeTrainings: Array<AudioFile>,
  registerPromise: Function,
};

type State = {
  toast?: string,
};

class ScribeSpeechTrainingSelector extends React.Component<Props, State> {
  clearToastTimeout: ?TimeoutID;

  constructor(props: Props) {
    super(props);
    this.clearToastTimeout = null;
    this.state = {};
  }

  startTrainingFile(title: string) {
    const { registerPromise } = this.props;

    const fetchTraining = registerPromise(
      fetchWithToken(
        `${getScribeBackendEndpoint()}/api/v1/training-conversations`,
        {
          method: 'POST',
          body: JSON.stringify({
            title,
          }),
        }
      )
    );

    fetchTraining.then(res => {
      this.setState({
        toast: res.status >= 200 && res.status < 400 ? title : 'error',
      });
      this.clearToastTimeout = setTimeout(() => {
        this.setState({
          toast: undefined,
        });
      }, 10000);
    });
  }

  componentWillUnmount() {
    if (this.clearToastTimeout) clearTimeout(this.clearToastTimeout);
  }

  render() {
    const {
      classes,
      conversationRequested,
      conversationStarted,
      openWebsocketCount,
    } = this.props;

    if (localStorage.getItem('scribeBackendUrl') === 'https://scribe.ava.me')
      return null;
    if (
      conversationRequested ||
      conversationStarted ||
      openWebsocketCount === 0
    ) {
      return null;
    }

    const { scribeTrainings } = this.props;
    const { toast } = this.state;

    return (
      <Toggle>
        {({ on, getTogglerProps }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <ListItem button {...getTogglerProps()}>
              <ListItemIcon>
                <i className="material-icons">audiotrack</i>
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary="Training Files"
              />
              <ListItemIcon>
                {(!on && <i className="material-icons">expand_more</i>) || (
                  <i className="material-icons">expand_less</i>
                )}
              </ListItemIcon>
            </ListItem>
            <Collapse in={on} timeout="auto" unmountOnExit>
              <List>
                {scribeTrainings &&
                  uniqBy(scribeTrainings, t => t.title).map(file => (
                    <ListItem button key={file.title}>
                      <ListItemText
                        classes={{ primary: classes.listItemText }}
                        onClick={() => {
                          this.startTrainingFile(file.title);
                        }}
                        primary={file.desc}
                      />
                    </ListItem>
                  ))}
              </List>
            </Collapse>
            {document.body
              ? ReactDOM.createPortal(
                  // eslint-disable-next-line react/jsx-indent
                  <Snackbar
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    open={!!toast}
                    onClose={() => {
                      this.setState({
                        toast: undefined,
                      });
                    }}
                    message={(
                      <span
                        style={{
                          color: toast === 'error' ? 'red' : undefined,
                        }}
                      >
                        {toast === 'error'
                          ? 'Something went wrong!'
                          : `${toast || ''} is starting`}
                      </span>
)}
                  />,
                  document.body
                )
              : null}
          </div>
        )}
      </Toggle>
    );
  }
}

export default makeComponentTrashable(ScribeSpeechTrainingSelector);
